import React from 'react';
import { IconButton, Tooltip } from '@folio/stripes/components';
import { t } from '../../../../services';
import css from './CrossTenantIcon.css';
export var CrossTenantIcon = function () {
    return (React.createElement(Tooltip, { text: t('cross-tenant-message') }, // @ts-ignore
    function (_a) {
        var ref = _a.ref, ariaIds = _a.ariaIds;
        return (React.createElement("span", null,
            React.createElement(IconButton, { iconClassName: css.crossTenantIcon, ref: ref, size: "small", icon: "exclamation-circle", "aria-labelledby": ariaIds.text, "aria-describedby": ariaIds.sub })));
    }));
};
